import {Button} from '@components/ui/button'
import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {Assignment, ServiceType} from '@features/assignment/types.ts'
import {Spinner} from '@components/ui/spinner'
import {useAssignmentCoordination} from '@features/assignment/queries/useAssignmentCoordination'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'

export const AcceptedNoHostDatesDescription = ({
    assignment,
    serviceType
}: {
    assignment: Assignment
    serviceType: ServiceType
}) => {
    const {t} = useTranslation()
    const assignmentCoordinationMutation = useAssignmentCoordination({
        assignmentId: assignment.id,
        taskId: assignment.task.id
    })

    return (
        <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
            <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                    {t('assignment:descriptions:accepted_no_dates_shared:title', {
                        hostName: assignment.host.first_name
                    })}
                </h3>
                <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                    {t(`assignment:descriptions:accepted_no_dates_shared:paragraph:${serviceType}` as TKey)}
                </p>
            </div>
            <Button
                disabled={assignmentCoordinationMutation.isPending}
                onClick={() => assignmentCoordinationMutation.mutate({status: 'host_contacted'})}
            >
                {t('assignment:descriptions:accepted_no_dates_shared:cta')}
                {assignmentCoordinationMutation.isPending && <Spinner size={20} />}
            </Button>
        </div>
    )
}
